import Formatter, { normalizeCnpj } from 'shared/utils/formatters'
import CreateFrotistaRequest from '../entities/CreateFrotistaRequest'
import CreateFrotistaResponse from '../entities/CreateFrotistaResponse'
import { IUserRepository } from '../repositories/IUserRepository'

export interface ICreateFrotista {
  execute(params: CreateFrotistaRequest): Promise<CreateFrotistaResponse>
}

export default class CreateFrotistaImpl implements ICreateFrotista {
  constructor(private readonly userRepository: IUserRepository) {}

  private validateValuesCreateFrotista(params: CreateFrotistaRequest): string {
    const erros: string[] = []

    let numero = params.endereco.numero
      ? params.endereco.numero.replace(/\D/g, '')
      : '0'
    if (!numero) {
      numero = '0'
    }
    params.endereco.numero = numero

    if (!params.cnpj) {
      erros.push('Cnpj')
    }

    if (!params.antt) {
      erros.push('Antt')
    }
    if (!params.email) {
      erros.push('Email')
    }
    if (!params.telefone) {
      erros.push('Telefone')
    }
    if (!params.doc_imagem_frente || !params.doc_imagem_verso) {
      erros.push('Foto do documento')
    }

    if (!params.endereco) {
      erros.push('Endereço')
    } else {
      if (!params.endereco.cep) {
        erros.push('Cep')
      }
      if (!params.endereco.logradouro) {
        erros.push('Logradouro')
      }
      if (!params.endereco.bairro) {
        erros.push('Bairro')
      }
      if (!params.endereco.cidade) {
        erros.push('Cidade')
      }
      if (!params.endereco.estado) {
        erros.push('Estado')
      }
      if (!params.endereco.cidade_ibge) {
        erros.push('Código ibge')
      }
    }

    if (!params.senha) {
      erros.push('Senha')
    }

    if (erros.length) {
      let errorMessage = ''

      if (erros.length > 1) {
        errorMessage = 'Os campos obrigatórios estão faltando: '
        errorMessage =
          errorMessage + erros.slice(0, -1).join(', ') + ' e ' + erros.slice(-1)
      } else {
        errorMessage =
          'O campo obrigatório está faltando: ' +
          errorMessage +
          erros.map(String)
      }

      return errorMessage
    }
  }

  public formatarDadosParams(
    params: CreateFrotistaRequest,
  ): CreateFrotistaRequest {
    return {
      ...params,
      cnpj: normalizeCnpj(params.cnpj),
      telefone: params.telefone.replace(Formatter.somenteNumeros(), ''),
      endereco: {
        ...params.endereco,
        cep: params.endereco.cep.replace(Formatter.somenteNumeros(), ''),
      },
    }
  }

  public async execute(
    params: CreateFrotistaRequest,
  ): Promise<CreateFrotistaResponse> {
    const errorMessage = this.validateValuesCreateFrotista(params)

    if (errorMessage) {
      throw new Error(errorMessage)
    }

    const response = await this.userRepository.createFrotista(
      this.formatarDadosParams(params),
    )

    return response
  }
}
